<template>
    <b-card>
      <div>
        <Strong>HUB-Wise Performance Report</Strong>
  
        <b-row class="mt-4">
          <b-col >                    
            <div>
              <ul class="nav nav-tabs nav-justified">
                <li class="nav-item">
                  <a @click="activeTab = 1;" class="nav-link" :class="{'active' : isActiveTab(1)}" >OFD Report</a>
                </li>
  
                <!-- <li class="nav-item">
                  <a @click="activeTab = 2;" class="nav-link " :class="{'active' : isActiveTab(2)}">OFP Report</a>
                </li>  -->
                
                <li class="nav-item">
                  <a @click="activeTab = 3;" class="nav-link " :class="{'active' : isActiveTab(3)}">RVP Report</a>
                </li> 
              </ul>
            </div>                       
          </b-col>
        </b-row>
  
        <component :is="currentComponent" class="mt-3"></component>
      </div>
    </b-card>
  </template>
    
  <script>
  import hubWiseOFDReport_KSA from './hubWiseOFDReport_KSA.vue';
  import hubWiseOFPReport_KSA from './hubWiseOFPReport_KSA.vue';
  import hubWiseRVPReport_KSA from './hubWiseRVPReport_KSA.vue';
  
    export default {
      components: {
        hubWiseOFDReport_KSA,
        hubWiseOFPReport_KSA,
        hubWiseRVPReport_KSA
      },
      data: function(){
        return{
          activeTab: 1,
          name: 'hubWisePerformanceReport_KSA',
        }
      },
      computed : {
        currentComponent() {
          if(this.activeTab === 1)           
            return "hubWiseOFDReport_KSA";
          else if(this.activeTab === 2)
            return "hubWiseOFPReport_KSA";
          else
            return "hubWiseRVPReport_KSA"
        }
      },
  
      created: function(){
        this.isActiveTab(1);
      },
      methods:{
        isActiveTab(id)
        {
          return this.activeTab === id;
        }
      }
    };
  </script>
  
  <style>
  
  </style>
    